export interface WorkspaceDefaults {
  logoLabel: string;
  name: string;
  domain: string;
  fiscalYearStart: string;
}

export type WorkspaceLogoDisplay =
  | { kind: 'image'; src: string }
  | { kind: 'initial'; initial: string };

export function getWorkspaceDefaults(): WorkspaceDefaults {
  return {
    logoLabel: 'parcel',
    name: 'parcel',
    domain: 'parcelengineering.com',
    fiscalYearStart: 'January',
  };
}

const fiscalYearStartMonths = new Set([
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]);

export function getWorkspaceFiscalYearStart(settings: unknown): string {
  if (typeof settings !== 'object' || settings === null || Array.isArray(settings)) {
    return 'January';
  }

  const value = (settings as { fiscalYearStart?: unknown }).fiscalYearStart;
  return typeof value === 'string' && fiscalYearStartMonths.has(value) ? value : 'January';
}

export function getWorkspaceDisplayDomain(
  companyDomain: string | null,
  companyDomains: string[],
): string {
  return companyDomain ?? companyDomains[0] ?? getWorkspaceDefaults().domain;
}

export function getWorkspaceInitial(name: string): string {
  return (name.trim().charAt(0) || 'w').toLowerCase();
}

export function getWorkspaceLogoDisplay(
  logoUrl: string | null,
  name: string,
): WorkspaceLogoDisplay {
  if (logoUrl) return { kind: 'image', src: logoUrl };

  return { kind: 'initial', initial: getWorkspaceInitial(name) };
}
